module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pb9"
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', [_c('v-flex', [(_vm.$store.getters.currentUserRoles.includes('embalmer')) ? _c('v-flex', {
    attrs: {
      "mb-5": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "mb-3": ""
    }
  }, [_c('h1', [_vm._v("TODO")])]), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "items": _vm.todoCases,
      "headers": _vm.todoCasesTableHeaders,
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.name ? props.item.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.wake_start))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.wake_end))])]
      }
    }], null, false, 3443140808)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-select', {
    attrs: {
      "items": _vm.displayPeriodList,
      "label": "Select period"
    },
    model: {
      value: (_vm.displayPeriod),
      callback: function($$v) {
        _vm.displayPeriod = $$v
      },
      expression: "displayPeriod"
    }
  })], 1)], 1), _vm._v(" "), _c('v-calendar', {
    ref: "calendar",
    staticClass: "theme-default",
    attrs: {
      "now": _vm.showDate,
      "value": _vm.calendarValue,
      "type": _vm.displayPeriod,
      "color": "primary"
    },
    on: {
      "click:date": _vm.onClickDate,
      "moved": _vm.onMove
    },
    scopedSlots: _vm._u([{
      key: "day",
      fn: function(ref) {
        var date = ref.date;

        return [_vm._l((_vm.eventsMap[date]), function(event) {
          return [_c('v-tooltip', {
            attrs: {
              "bottom": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function(ref) {
                var on = ref.on;

                return [_c('div', _vm._g({
                  directives: [{
                    name: "ripple",
                    rawName: "v-ripple"
                  }],
                  staticClass: "my-event",
                  class: {
                    'manager-class': _vm.isCaseManagerEqual(event),
                    'not-manager': !_vm.isCaseManagerEqual(event)
                  },
                  domProps: {
                    "innerHTML": _vm._s(event.time + ' ' + event.title)
                  },
                  on: {
                    "click": function($event) {
                      return _vm.onClickEvent(event)
                    }
                  }
                }, on))]
              }
            }], null, true)
          }, [_vm._v(" "), _c('span', {
            domProps: {
              "innerHTML": _vm._s(event.title)
            }
          })])]
        })]
      }
    }, {
      key: "dayBody",
      fn: function(ref) {
        var date = ref.date;
        var timeToY = ref.timeToY;
        var minutesToPixels = ref.minutesToPixels;

        return [_vm._l((_vm.eventsMap[date]), function(event) {
          return [(event.time) ? _c('div', {
            key: event.id,
            staticClass: "my-event with-time",
            class: {
              'manager-class': _vm.isCaseManagerEqual(event),
              'not-manager': !_vm.isCaseManagerEqual(event)
            },
            style: ({
              top: timeToY(event.time) + 'px',
              height: minutesToPixels(event.duration) + 'px'
            }),
            domProps: {
              "innerHTML": _vm._s(event.title)
            },
            on: {
              "click": function($event) {
                return _vm.onClickEvent(event)
              }
            }
          }) : _vm._e()]
        })]
      }
    }])
  }), _vm._v(" "), _c('AddScheduledCaseButton'), _vm._v(" "), (_vm.dateForNewLead) ? _c('AddCaseNameAndDateDialog', {
    attrs: {
      "date": _vm.dateForNewLead
    },
    on: {
      "input": _vm.loadSchedules
    },
    model: {
      value: (_vm.dialogModel),
      callback: function($$v) {
        _vm.dialogModel = $$v
      },
      expression: "dialogModel"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "text-sm-left text-xs-center",
    attrs: {
      "md6": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.prev()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("keyboard_arrow_left")]), _vm._v("\n            Prev\n          ")], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$refs.calendar.next()
      }
    }
  }, [_vm._v("\n            Next\n            "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("keyboard_arrow_right")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "legend-box case-manager"
  }), _vm._v(" – you are a case manager\n    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "legend-box not-case-manager"
  }), _vm._v(" – you aren't a case manager\n    "), _c('br'), _c('br')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d67d01c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddLeadForm.vue
// module id = 970
// module chunks = 1